import { computed, getCurrentInstance, ref } from "@vue/composition-api";
export const useShowMoreToggle = () => {
  const internalInstance = getCurrentInstance();
  const showMore = ref(false);
  const showMoreButtonText = computed(() => showMore.value ? internalInstance == null ? void 0 : internalInstance.proxy.$t("global.actions.showLess") : internalInstance == null ? void 0 : internalInstance.proxy.$t("global.actions.showMore"));
  const showMoreButtonIcon = computed(() => showMore.value ? "chevron-up" : "chevron-down");
  const toggleShowMore = () => {
    showMore.value = !showMore.value;
  };
  return {
    showMore,
    showMoreButtonText,
    showMoreButtonIcon,
    toggleShowMore
  };
};